import { render, staticRenderFns } from "./CompanyEditButtons.vue?vue&type=template&id=8bbab308&"
import script from "./CompanyEditButtons.vue?vue&type=script&lang=js&"
export * from "./CompanyEditButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports